import React from 'react';
import {connect} from 'react-redux';
import {closeNotification} from 'Actions/notification';
import util from 'Utils/commonUtil';
import {T} from 'Actions/translate';

class Notification extends React.Component {
    constructor() {
        super();

        this.notificationDOM = React.createRef();
        this.confirmCreated = false;
    }

    componentWillReceiveProps(newProps) {
        if (newProps.msg) {
            let type = newProps.type || 'success';
            let options = newProps.options || {};
            let msg = newProps.msg;

            options.time = options.time || 8000;

            this.open(type, msg, options);
        }
    }

    /**
     * create notification element
     **/
    open = (type, msg, options) => {
        if (type === 'confirm' && this.confirmCreated) return;

        let div = document.createElement('div');
        let msgBox = document.createElement('p');
        // let textarea = document.createElement('textarea');

        div.className = 'notification-content';
        if (options.testid) {
            div.setAttribute('data-testid', options.testid);
        }
        msgBox.className = 'notification-msg';
        msgBox.innerHTML = msg;

        div.appendChild(msgBox);
        this.notificationDOM.current.appendChild(div);

        if (type === 'confirm') {
            let menuBox = document.createElement('div');
            let cancelBtn = document.createElement('button');
            let confirmBtn = document.createElement('button');

            this.confirmCreated = true;

            msgBox.style.minHeight = '5rem';

            menuBox.className = 'menu-box';
            cancelBtn.className = 'btn-cancel';
            confirmBtn.className = 'btn-confirm';
            cancelBtn.innerText =
                options.cancelText || T('shopping_cart_close');
            confirmBtn.innerText = options.confirmText || T('order_confirm');

            util.clickOfSingleTap(cancelBtn, () => {
                div.addEventListener('transitionend', () => {
                    this.notificationDOM.current.removeChild(div);
                    this.confirmCreated = false;
                });
                div.style.transition = 'opacity 0.3s';
                div.style.opacity = '0';
            });
            util.clickOfSingleTap(confirmBtn, () => {
                if (util.isFunction(options.confirm)) options.confirm();

                div.addEventListener('transitionend', () => {
                    this.notificationDOM.current.removeChild(div);
                    this.confirmCreated = false;
                });
                div.style.transition = 'opacity 0.3s';
                div.style.opacity = '0';
            });

            menuBox.appendChild(cancelBtn);
            menuBox.appendChild(confirmBtn);
            div.appendChild(menuBox);
        } else {
            div.addEventListener('animationend', () => {
                this.notificationDOM.current.removeChild(div);
            });
        }

        div.style.left = -div.offsetWidth / 2 + 'px';
        div.style.top = -div.offsetHeight / 2 + 'px';

        switch (type) {
            case 'success':
                div.style.animation = `notification-success-animation ${options.time}ms`;
                break;
            case 'danger':
                div.style.animation = `notification-danger-animation ${options.time}ms`;
                break;
            default:
        }

        if (options.bubbling) {
            document.getElementById('root').style.position = 'initial';
        }

        this.props.closeNotification();
    };

    render() {
        return (
            <div
                ref={this.notificationDOM}
                className="notification-modal"></div>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        msg: state.notification.msg,
        type: state.notification.type,
        options: state.notification.options,
    };
};

let mapDispatchToProps = {
    closeNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
